import React from 'react';
import { Flex } from '@adsk/alloy-react-box';
import ContentLoader from '@adsk/alloy-react-content-loader';
const TemplateRowLoaderItem = () => /*#__PURE__*/React.createElement(ContentLoader, {
  width: 285,
  height: 50,
  viewBox: "0 0 285 50"
}, /*#__PURE__*/React.createElement("rect", {
  x: "0",
  y: "17",
  rx: "3",
  ry: "3",
  width: "120",
  height: "6"
}), /*#__PURE__*/React.createElement("rect", {
  x: "0",
  y: "30",
  rx: "3",
  ry: "3",
  width: "180",
  height: "6"
}));
const TemplateRowLoader = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Flex, {
  "data-testid": "TemplateRowLoader",
  alignItems: "center",
  height: "60px",
  padding: "8px 16px"
}, /*#__PURE__*/React.createElement(TemplateRowLoaderItem, null)), /*#__PURE__*/React.createElement(Flex, {
  alignItems: "center",
  height: "60px",
  padding: "8px 16px"
}, /*#__PURE__*/React.createElement(TemplateRowLoaderItem, null)), /*#__PURE__*/React.createElement(Flex, {
  alignItems: "center",
  height: "60px",
  padding: "8px 16px"
}, /*#__PURE__*/React.createElement(TemplateRowLoaderItem, null)));
TemplateRowLoader.displayName = 'TemplateRowLoader';
export default TemplateRowLoader;
//# sourceMappingURL=TemplateRowLoader.js.map